<!--<div class="title"><b>LOG IN</b> TO YOUR ACCOUNT</div>
<div>
  <div>
    <div class="input-container">
      <span class="fa fa-fw fa-user"></span>
      <input type="text" name="username" class="username" placeholder="Username" [(ngModel)]="form.username" />
    </div>
    <div class="input-container">
      <span class="fa fa-fw fa-lock"></span>
      <input type="password" name="password" class="password" placeholder="{{ 'general.password' | translate }}" [(ngModel)]="form.password" />
    </div>
    <div>
      <button type="submit" class="btn btn-primary" (click)="login()" [disabled]="loggingIn"><i class="fa fa-spin fa-spinner" *ngIf="loggingIn"></i><span *ngIf="!loggingIn">Login</span> </button>
    </div>
    <div style="position: relative; height: 25px;">
      <a routerLink="/forgotpassword" class="forgotpassword">Forgot password?</a>
    </div>
    <div class="error" *ngIf="error">
      <span>{{errorMessage}}</span>
    </div>
  </div>
</div>-->

<div class="title">LOGIN TO YOUR ACCOUNT</div>
<div class="margin-top-48">
    <div>
    <span class="p-float-label">
      <input pInputText type="text" id="username" name="username" class="username" [(ngModel)]="form.username"/>
      <label for="username">Email</label>
    </span>
        <span class="p-float-label margin-top-32">
      <input pInputText type="password" id="password" name="password" class="password" [(ngModel)]="form.password"/>
      <label for="password">Password</label>
    </span>
        <div>
            <button type="submit" class="btn btn-primary" (click)="login()"
                    [disabled]="loggingIn || (form.username.length===0 || form.password.length===0)"><i
                    class="fa fa-spin fa-spinner" *ngIf="loggingIn"></i><span *ngIf="!loggingIn">Login</span></button>
        </div>
        <div style="display: flex;">
            <a routerLink="/forgotpassword" class="forgotpassword">Forgot password?</a>
        </div>
    </div>
</div>
<div class="error" *ngIf="error">
    <span>{{errorMessage}}</span>
</div>
